module.exports = __webpack_public_path__ + "img/20.98e6b05d.png";